module.exports = {"component":"vertical-navigation","status":"prod","display-name":"Vertical Navigation","SLDS-component-path":"/components/vertical-navigation","url-slug":"vertical-navigation"}


//////////////////
// WEBPACK FOOTER
// ./components/vertical-navigation/docs.json
// module id = 290
// module chunks = 0